const formatNumber = (value) => {
  const result = parseFloat(value, 0);

  if (`${result}` === "NaN") {
    return "0";
  }

  if (result < 0) {
    return `-${commatize(result.toFixed(0) * -1)}`;
  }

  return `${commatize(result.toFixed(0))}`;
};

const roundDecimal = (value, decimalPlaces) => {
  const _dp = decimalPlaces || 2;
  const result = parseFloat(value, _dp);

  if (`${result}` === "NaN") {
    return 0;
  }

  return (Math.round(result * 100) / 100).toFixed(_dp);
};

const formatDecimal = (value, decimalPlaces) => {
  const _dp = decimalPlaces === 0 ? 0 : decimalPlaces || 2;
  let result = parseFloat(value, _dp);

  if (value === Infinity || `${result}` === "NaN") {
    return "0";
  }

  if (_dp > 1) {
    const decimalPlacesToRoundTo = 100 * _dp;
    result =
      Math.round(result * decimalPlacesToRoundTo) / decimalPlacesToRoundTo;
  }

  if (result < 0) {
    return `-${commatize((result * -1).toFixed(_dp))}`;
  }

  return `${commatize(result.toFixed(_dp))}`;
};

const formatCurrency = (value, decimalPlaces) => {
  const _dp = decimalPlaces === 0 ? 0 : decimalPlaces || 2;
  let result = parseFloat(value, 2);

  if (`${result}` === "NaN") {
    return "$0";
  }

  if (_dp > 1) {
    const decimalPlacesToRoundTo = 100 * _dp;
    result =
      Math.round(result * decimalPlacesToRoundTo) / decimalPlacesToRoundTo;
  }

  if (result < 0) {
    return `-$${commatize((result * -1).toFixed(_dp))}`;
  }

  return `$${commatize(result.toFixed(_dp))}`;
};

const formatPercent = (value, decimalPlaces) => {
  const _dp = decimalPlaces === 0 ? 0 : decimalPlaces || 2;
  let result = parseFloat(value, _dp);

  if (`${result}` === "NaN" || result === Infinity) {
    return "0%";
  }

  if (_dp > 1) {
    const decimalPlacesToRoundTo = 100 * _dp;
    result =
      Math.round(result * decimalPlacesToRoundTo) / decimalPlacesToRoundTo;
  }

  if (result < 0) {
    return `-${commatize((result * -1).toFixed(_dp))}%`;
  }

  return `${commatize(result.toFixed(_dp))}%`;
};

const formatPhone = (value) => {
  if (!value || value === null) {
    return "";
  }

  const digits = value.replace(/\D/g, "");

  if (digits.length >= 7) {
    return `(${digits.substring(0, 3)}) ${digits.substring(
      3,
      6
    )}-${digits.substring(6, 10)}`;
  } else if (digits.length >= 4) {
    return `${digits.substring(0, 3)} ${digits.substring(3, 6)}`;
  }

  return digits;
};

const commatize = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export {
  formatNumber,
  formatDecimal,
  formatCurrency,
  formatPercent,
  formatPhone,
  roundDecimal,
};
